<template>
	<div>
		<CommunicationThread
			ref="thread"
			data-tour="conversation"
			:message-id="item._id"
			:order-id="(item.order && item.order.OrderId) || ''"
			:order-mongo-id="(item.order && item.order._id) || ''"
			@open-order="$emit('open-order')"
			@caricato="caricato"
		/>
		<ReplyComposer
			v-if="email"
			ref="replyComposer"
			class="mt-3"
			:destinatario="destinatario"
			:email="email"
			:ultimo-oggetto="ultimoOggetto"
			:invio="invio"
			@send="invia"
		/>
		<div v-else class="grey--text text-caption mt-3">Nessun indirizzo email del cliente: impossibile rispondere</div>

		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="5000">
			{{ snackbar.text }}
			<v-btn dark text @click="snackbar.snackbar = false"> Close </v-btn>
		</v-snackbar>
	</div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapMutations } from 'vuex';
import { testoDaEntita } from '@/utils/emailHtml';
import CommunicationThread from './CommunicationThread.vue';
import ReplyComposer from './ReplyComposer.vue';

// conversazione di una riga di /communications con il modulo di risposta sotto (come nella scheda ordine)
export default {
	name: 'CommunicationConversation',
	components: { CommunicationThread, ReplyComposer },
	props: {
		// la communication della riga: da qui arrivano cliente e ordine della risposta
		item: { type: Object, required: true },
	},
	data() {
		return { ultimoOggetto: this.item.subject || '', invio: false, snackbar: { snackbar: false, color: 'success', text: '' } };
	},
	computed: {
		...mapGetters({
			getUrl: 'settings/getUrl',
			getToken: 'profile/getToken',
		}),
		email() {
			return (this.item.buyer && this.item.buyer.email) || '';
		},
		destinatario() {
			const b = this.item.buyer || {};
			return testoDaEntita([b.name, b.lastname].filter(Boolean).join(' '));
		},
	},
	methods: {
		...mapMutations({
			setLogout: 'profile/setLogout',
		}),
		// l'oggetto proposto e' quello dell'ultimo messaggio della conversazione
		caricato(messaggi) {
			const ultimo = [...(messaggi || [])].reverse().find(m => m.subject);
			if (ultimo) this.ultimoOggetto = ultimo.subject;
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, text };
		},
		// risposta dal ReplyComposer: { subject, text, attachments } + cliente/ordine della riga
		async invia(risposta) {
			const payload = { type: 'email', owner: 'Store', buyer: this.item.buyer, ...risposta };
			if (this.item.order && (this.item.order._id || this.item.order.OrderId)) payload.order = this.item.order;
			this.invio = true;
			try {
				const { data } = await axios.post(`${this.getUrl}communications/store`, payload, { headers: { Authorization: `Bearer ${this.getToken}` } });
				if (data && data.data && data.data._id) {
					this.$refs.thread.aggiungi(data.data);
					this.ultimoOggetto = data.data.subject || this.ultimoOggetto;
				}
				this.$refs.replyComposer && this.$refs.replyComposer.reset();
				this.notifica('success', 'Risposta inviata al cliente');
				this.$emit('inviato', data && data.data);
			} catch (err) {
				const errors = (err.response && err.response.data && err.response.data.error) || [];
				this.notifica('error', (Array.isArray(errors) ? errors.map(e => e.msg).join('\n') : '') || 'Invio non riuscito, riprova');
				if (err.response && err.response.status === 401) {
					this.setLogout();
					this.$router.push('/login');
				}
			} finally {
				this.invio = false;
			}
		},
	},
};
</script>
